// src/context/DetalleMutuoContext.tsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { OrigenDetalleMutuo } from '../utils/enums';

type DetalleMutuoData = {
    id?: string;
    nombre?: string;
    idSolicitud?: string;
    filtros?: any;
    tipoMutuo?: string;
    origen?: OrigenDetalleMutuo;
    numeroOperacion?: string;
};

const DetalleMutuoContext = createContext<DetalleMutuoData>({});
const DetalleMutuoUpdaterContext = createContext<(data: DetalleMutuoData) => void>(() => { });

export const useDetalleMutuo = () => useContext(DetalleMutuoContext);
export const useSetDetalleMutuo = () => useContext(DetalleMutuoUpdaterContext);

export const DetalleMutuoProvider = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const [data, setData] = useState<DetalleMutuoData>({});

    useEffect(() => {
        if (location.state?.id) {
            setData(location.state);
        }
    }, [location.state]);

    return (
        <DetalleMutuoContext.Provider value={data}>
            <DetalleMutuoUpdaterContext.Provider value={setData}>
                {children}
            </DetalleMutuoUpdaterContext.Provider>
        </DetalleMutuoContext.Provider>
    );
};
